import React from 'react';
import SData from "../../helpers/SData";
import Tag from "../views/Tag";
import {CheckOutlined, ClockCircleOutlined, CloseOutlined, HolderOutlined, ToolOutlined} from "@ant-design/icons";
import SystemFunctions from "../../helpers/SystemFunctions";
import Card from "../views/Card";
import {SortableHandle} from "react-sortable-hoc";
import PropTypes from "prop-types";
import "./TaskItem.less";

const DragHandle = SortableHandle(() => <div className='handler'><HolderOutlined/></div>);

class TaskItem extends React.PureComponent {

    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    render() {
        if (SData.base == null) {
            return null;
        }
        let {id, value, fullDescTask, editMode} = this.props;
        const options = SData.base.global.tasksTags;
        let tags = [];
        for (let i = 0; i < value.tags.length; i++) {
            let tag = value.tags[i];
            if (options[tag] == null) {
                continue;
            }
            tags.push(<Tag color={options[tag].color}>{options[tag].label}</Tag>)
        }
        let statusTag = null;
        switch (value.status) {
            case 0:
                statusTag = <Tag icon={<ClockCircleOutlined/>}
                                 className='primary'>{SystemFunctions.secondsToTextTimeout(value.time * 60)}</Tag>;
                break;
            case 1:
                statusTag = <Tag icon={<CheckOutlined/>}
                                 className='primaryGreen'>Выполнена</Tag>;
                break;
            case 2:
                statusTag = <Tag icon={<CloseOutlined/>}
                                 className='primaryRed'>Отменена</Tag>;
                break;
        }
        return (
            <div className={'TaskItem ' + (editMode ? 'draggable' : 'not-draggable')}>
                <Card>
                    <div className='main'>
                        <div className='name'>
                            <span className='taskId'>{id + 1}</span>
                            <div className='text'>{value.name}</div>
                        </div>
                        {value.data.description == null || value.data.description == '' ? <div className='noDesc'/> :
                            <div
                                className={'desc ' + (fullDescTask ? 'fullDesc' : 'prevDesc')}
                                onClick={() => this.props.onSetFullDesk(id, value)}>{value.data.description}</div>}
                        <div className='bottomContainer'>
                            <div className='tags'>
                                <span className='time'>
                                    {statusTag}
                                </span>
                                {editMode && value.status !== 1 ? <span className='edit'>
                                    <Tag className='primaryGeekblue' icon={<ToolOutlined/>}
                                         onClick={() => this.props.onEdit(id, value)}/>
                                </span> : null}
                                {tags}
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        {editMode ? <DragHandle/> : <div className='noDragPlaceholder'/>}
                    </div>
                </Card>
            </div>
        );
    }
}

TaskItem.propTypes = {
    id: PropTypes.number,
    value: PropTypes.object,
    fullDescTask: PropTypes.bool,
    editMode: PropTypes.bool,
    onEdit: PropTypes.func,
    onSetFullDesk: PropTypes.func,
};
TaskItem.defaultProps = {
    editMode: false,
}

export default TaskItem;